import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/INKBOARD4.png'
import _imports_1 from '@/assets/INKBOARD6.png'
import _imports_2 from '@/assets/INKBOARD3.png'
import _imports_3 from '@/assets/INKBOARD2.png'


const _hoisted_1 = {
  class: "grid grid-cols-1 gap-24 mt-20 lg:grid-cols-2 md:grid-cols-1 lg:mt-64",
  id: "mockup-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "z-10 mocks",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "title-column" }
const _hoisted_4 = { class: "text-column" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "z-10 mocks",
  src: _imports_1
}, null, -1)
const _hoisted_6 = { class: "title-column" }
const _hoisted_7 = { class: "text-column" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "z-10 mocks",
  src: _imports_2
}, null, -1)
const _hoisted_9 = { class: "title-column" }
const _hoisted_10 = { class: "text-column" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "z-10 mocks",
  src: _imports_3
}, null, -1)
const _hoisted_12 = { class: "title-column" }
const _hoisted_13 = { class: "text-column" }
const _hoisted_14 = { class: "exclusive text-base text-white pb-1 bold-text mt-8 lg:mt-16" }
const _hoisted_15 = { class: "download-button flex justify-center pb-1" }
const _hoisted_16 = {
  key: 0,
  href: "itms-apps://itunes.apple.com/app/inksquad-artist/id1579690331",
  target: "_blank"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", { class: "px-8 py-3 standard-button-blue rounded-full uppercase button-text mx-2 mb-1" }, "Download", -1)
const _hoisted_18 = { class: "exclusive text-xs text-gray-200" }
const _hoisted_19 = {
  key: 1,
  href: "https://itunes.apple.com/app/inksquad-artist/id1579690331",
  target: "_blank"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", { class: "px-8 py-3 standard-button-blue rounded-full uppercase button-text mx-2 mb-1" }, "Download", -1)
const _hoisted_21 = { class: "exclusive text-xs text-gray-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColumnItem = _resolveComponent("ColumnItem")!
  const _component_VideoPlayerModal = _resolveComponent("VideoPlayerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ColumnItem, {
        onVideo: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showVideo()))
      }, {
        image: _withCtx(() => [
          _hoisted_2
        ]),
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards2.title-1')), 1)
        ]),
        text: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards2.text-1')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_ColumnItem, {
        onVideo: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showVideo()))
      }, {
        image: _withCtx(() => [
          _hoisted_5
        ]),
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('components.homepage.wheelandmatrix.title-1')), 1)
        ]),
        text: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('components.homepage.wheelandmatrix.text-2')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_ColumnItem, {
        onVideo: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showVideo()))
      }, {
        image: _withCtx(() => [
          _hoisted_8
        ]),
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards2.title-2')), 1)
        ]),
        text: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards2.text-2')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_ColumnItem, {
        onVideo: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showVideo()))
      }, {
        image: _withCtx(() => [
          _hoisted_11
        ]),
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards2.title-3')), 1)
        ]),
        text: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('components.homepage.mockupinkboards2.text-3')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('components.general.availability')), 1),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.operatingSystem.os === 'Mac OS')
        ? (_openBlock(), _createElementBlock("a", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('components.general.availability')), 1)
          ]))
        : (_openBlock(), _createElementBlock("a", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('components.general.availability')), 1)
          ]))
    ]),
    (_ctx.isShowVideo)
      ? (_openBlock(), _createBlock(_component_VideoPlayerModal, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowVideo=false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}